import { mapState } from "pinia";
import { LayoutTypes } from "@/services/context/layout-helper";
import { useContextStore } from '@/store/context'
import { useGtm } from '@gtm-support/vue-gtm';

export const useUpdateCartTracking = () => {
  const gtm = useGtm();
  const contextStore = useContextStore();

  const { layout } = storeToRefs(contextStore);

  const trackUpdateCart = (payload) => {
    const finalProducts = [];
    const products = payload.products
    for (let i = 0; i < products.length; i++) {
      const article = {
        id: products[i].id,
        name: products[i].designation,
        price: products[i].prix || 'indisponible',
        quantity: products[i].quantity,
        dimension12: products[i].nombre_images,
        dimension11: "",
        metric3: products[i].taux_tva || 'indisponible',
        metric4: products[i].prix_ht || 'indisponible',
        category: products[i].category_path,
        isDejaAchete: products[i].is_deja_achete
      }
      if (products[i].discount_amount) { article.metric5 = products[i].discount_amount }
      if (products[i].coloris && products[i].taille) {
        article.variant = `${products[i].taille} | ${products[i].coloris}`
      }
      if (products[i].reviews_count && products[i].review_rate > 0) {
        article.dimension13 = products[i].reviews_count;
        article.dimension10 = products[i].review_rate;
      }

      if (products[i].marque) {
        article.brand = products[i].marque;
      }
      if (products[i].context) {
        article.context = products[i].context
      }
      finalProducts.push(article)
    }
    const pushObject = {
      ecommerce: {},
      nonInteraction: false,
      categoryGA: 'ecommerce'
    }
    let event = trackingCodes.ACTIONGA.addToCart;
    let actionGA = trackingCodes.ACTIONGA.addToCart;
    if (payload.method === "delete") {
      pushObject.ecommerce.remove = { products: finalProducts }
      event = trackingCodes.REMOVEFROMCART;
      actionGA = trackingCodes.REMOVEFROMCART;
    } else {
      pushObject.ecommerce.currencyCode = trackingCodes.CURRENCYCODE
      pushObject.ecommerce.add = { products: finalProducts }
    }
    if(payload.action) {
      pushObject.action = payload.action
    }
    pushObject.event = event
    pushObject.actionGA = actionGA
    pushObject.sitetype = layout.value === LayoutTypes.default ? 'd' : 'm'
    try {
      gtm.trackEvent(pushObject)
    } catch { }
  }
  return { trackUpdateCart }
}
